import { ContentfulErrors } from 'services/ContentfulService/utils'
import { ITopicFields } from 'generated/types/contentful'
import { parseTopic, Topic } from 'services/ContentfulService/models/topics'
import { buildContentfulHooks } from 'services/ContentfulService/hooks/template'
import { ObjectNotFoundError } from 'services/ContentfulService/errors'

const [useTopicsHook, getTopicsHook, topicFetcher] = buildContentfulHooks<Topic, ITopicFields>('topic', parseTopic)

export const useTopics = useTopicsHook
export const getTopics = getTopicsHook

export const getTopicBySlug = async (slug: string): Promise<Topic> => {
	const constraints = [{ 'fields.slug': slug }]
	const topics = await topicFetcher(JSON.stringify(constraints), 1)
	const topic = topics.shift()
	if (topic) return topic
	throw new ObjectNotFoundError('topic')
}

export const getTopicById = async (id: string): Promise<Topic> => {
	const constraints = [{ 'sys.id': id }]
	const topics = await topicFetcher(JSON.stringify(constraints), 1)
	const topic = topics.shift()
	if (topic) return topic
	throw ContentfulErrors.NotFound
}
